import type { TruncateLabelToFit } from "./types";

const ELLIPSIS = "…";

export const truncateLabelToFit: TruncateLabelToFit = ({
  label,
  availableWidth,
  ctx,
}) => {
  if (availableWidth <= 0) return "";

  const fullWidth = ctx.measureText(label).width;
  if (fullWidth <= availableWidth) return label;

  const ellipsisWidth = ctx.measureText(ELLIPSIS).width;
  const targetWidth = availableWidth - ellipsisWidth;
  if (targetWidth <= 0) return ELLIPSIS;

  // Binary search for the longest prefix whose width fits in targetWidth.
  let low = 0;
  let high = label.length;
  while (low < high) {
    const mid = (low + high + 1) >>> 1;
    const prefixWidth = ctx.measureText(label.slice(0, mid)).width;
    if (prefixWidth <= targetWidth) low = mid;
    else high = mid - 1;
  }

  return label.slice(0, low) + ELLIPSIS;
};
